import { get } from './client.js';

export const statsApi = {
    /**
     * GET /api/ivr/calls/stats
     * @param {string} hostId
     * @param {{ fromMillis?: number, toMillis?: number }} range
     */
    callStats: (hostId, range = {}) => {
        const qs = new URLSearchParams({ hostId });
        if (range.fromMillis) qs.set('fromMillis', String(range.fromMillis));
        if (range.toMillis) qs.set('toMillis', String(range.toMillis));
        if (range.avatarId) qs.set('avatarId', String(range.avatarId));
        return get(`/api/ivr/calls/stats?${qs.toString()}`);
    },

    /**
     * GET /api/ivr/calls/handoff-ratings — 真人客服服務滿意度匯總
     * @param {string} hostId
     * @param {{ fromMillis?: number, toMillis?: number }} range
     * @returns {{ count, avg, dist, byAgent: [{uid,name,count,avg}] }}
     */
    handoffRatings: (hostId, range = {}) => {
        const qs = new URLSearchParams({ hostId });
        if (range.fromMillis) qs.set('fromMillis', String(range.fromMillis));
        if (range.toMillis) qs.set('toMillis', String(range.toMillis));
        return get(`/api/ivr/calls/handoff-ratings?${qs.toString()}`);
    },
};
